import React from 'react';
import PropTypes from 'prop-types';
import {
  PlusIcon,
  TrashIcon,
  PencilIcon,
  EyeIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  XMarkIcon,
  UserIcon,
  BellIcon,
  SparklesIcon,
  ArchiveBoxArrowDownIcon,
  FunnelIcon,
  PaperAirplaneIcon,
  StopIcon,
  ArrowDownTrayIcon,
  ChatBubbleLeftRightIcon,
  EllipsisVerticalIcon,
  EllipsisHorizontalIcon,
  TagIcon
} from '@heroicons/react/24/outline';

/**
 * Icon Atom - wrapper dla Heroicons z standaryzowanymi rozmiarami
 */

// Mapa dostępnych ikon
const iconMap = {
  plus: PlusIcon,
  trash: TrashIcon,
  pencil: PencilIcon,
  eye: EyeIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  'x-mark': XMarkIcon,
  user: UserIcon,
  bell: BellIcon,
  sparkles: SparklesIcon,
  'archive-box': ArchiveBoxArrowDownIcon,
  funnel: FunnelIcon,
  'paper-airplane': PaperAirplaneIcon,
  stop: StopIcon,
  'arrow-down-tray': ArrowDownTrayIcon,
  'chat-bubble': ChatBubbleLeftRightIcon,
  'ellipsis-vertical': EllipsisVerticalIcon,
  'ellipsis-horizontal': EllipsisHorizontalIcon,
  tag: TagIcon
};

const Icon = ({ 
  name,
  size = 'md',
  color = 'current',
  className = '',
  ...props 
}) => {
  const IconComponent = iconMap[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in iconMap`);
    return null;
  }

  const sizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  };

  const colorClasses = {
    current: 'text-current',
    primary: 'text-primary-500',
    secondary: 'text-gray-500',
    success: 'text-green-500',
    warning: 'text-yellow-500',
    error: 'text-red-500',
    white: 'text-white'
  };

  const classes = [
    sizeClasses[size],
    colorClasses[color],
    className
  ].filter(Boolean).join(' ');

  return <IconComponent className={classes} {...props} />;
};

Icon.propTypes = {
  name: PropTypes.oneOf(Object.keys(iconMap)).isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  color: PropTypes.oneOf(['current', 'primary', 'secondary', 'success', 'warning', 'error', 'white']),
  className: PropTypes.string,
};

export default Icon;
export { iconMap };
